import React, { useState, useContext } from 'react'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router'
import ServerError from '../../../../lib/components/ServerError'
import { caseSuccessUrl } from '../../../routing/paths'
import StoreContext from '../../../providers/storesContext'
import Button from '../../../components/Button'
import CaseCheckoutCashStore from './CaseCheckoutCashStore'
import TermsAndConditions from '../../../components/Checkout/TermsAndConditions'
import InvoiceSummary from '../components/InvoiceSummary'
import BasicForm from './components/BasicForm'

const CaseCheckoutCash = () => {
  const history = useHistory()
  const { caseDetailStore } = useContext(StoreContext)
  const [caseCheckoutCreditCash] = useState(() => new CaseCheckoutCashStore(caseDetailStore))

  const { immobilizationCase } = caseDetailStore

  const handleSubmit = () => {
    caseCheckoutCreditCash.checkout().then((result) => {
      if (result !== false) {
        location.href = caseSuccessUrl(immobilizationCase)
      }
    })
  }
  const handleToggleTerms = () => caseCheckoutCreditCash.toggleTerms()

  const { agreedTerms, isLoading, globalError, termsError } = caseCheckoutCreditCash

  return (
    <div>
      <BasicForm caseCheckoutStore={caseCheckoutCreditCash} />
      <TermsAndConditions handleToggleTerms={handleToggleTerms} agreedTerms={agreedTerms} />
      {termsError && <ServerError message="You must accept the terms and conditions" />}
      <InvoiceSummary />
      {globalError !== '' && <ServerError message={globalError} />}
      <div>
        <Button extraStyle="w-full mb-8 mt-4" onClick={handleSubmit} isLoading={isLoading}>
          Submit
        </Button>
      </div>
    </div>
  )
}

export default observer(CaseCheckoutCash)
